

import React, {useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import './dnd.css'
import VisualAppFlow from './VisualAppFlow';
import VisualScreenFlow from './VisualScreenFlow';

import { LightTooltip } from './LightTooltip';
import IconButton from "@material-ui/core/IconButton";
import ScreenIcon from '@material-ui/icons/VideoLabel';
import AppIcon from '@material-ui/icons/Apps';

  const AppFlow = (props) => {


    const [entityName, setEntityName] = useState(['New'])
    const [appView, setAppView] = useState(false)

    const useStyles = makeStyles({
      designerIconButton:{
        height:30,
        float: 'right'
      },
  
    });

    const classes = useStyles();

    const renderView = ()=>{
        if(appView){
          return(
          <div>
          <LightTooltip title="Screen View">
              <IconButton variant="contained"
                color="primary" size="small" className={classes.designerIconButton} onClick={()=>{
                  setAppView(false);
                  }}>
                <ScreenIcon fontSize="large"/>

              </IconButton>
          </LightTooltip>
          <VisualAppFlow data={props.data} currentTaskName={currentTaskName} appSet={props.appSet} totalTime={props.totalTime } mostTimeSpent={props.mostTimeSpent} mostTimeSpentApp={props.mostTimeSpentApp} appHops={props.appHops}/>
          </div>
            );
          }

        else{
          return(
            <div>
          <LightTooltip title="App View">
              <IconButton variant="contained"
                color="primary" size="small" className={classes.designerIconButton} onClick={()=>{
                  setAppView(true); 
                  }}>
                <AppIcon fontSize="large"/>

              </IconButton>

          </LightTooltip>
          <VisualScreenFlow loading={props.loading} currentTaskName={currentTaskName} data={props.visdata}  numScreens={props.numScreens} totalTime={props.totalTime } />
          
          </div>
          );  
        }

    }

    var currentTaskName = "(Select a submission from Submissions Tab)"
    if (props.currentTaskName != undefined && props.currentTaskName != null && props.currentTaskName != "")
    currentTaskName = props.currentTaskName
    return (

          <div className="cont">
              {renderView()}

          </div>

    );


  };

  
  export default AppFlow;